// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemResultsGetBody = {
  poolId: string;
  roundId?: string | null;
  userId?: string | null;
};

export type typePickemResultsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    round: {
      roundId: string;
      label: string;
      status: "scheduled" | "open" | "locked" | "graded";
      isScored: boolean;
    };
    games: {
      eventId: string;
      homeTeamId: string;
      awayTeamId: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      isLocked: boolean;
      homeScore?: number | null;
      awayScore?: number | null;
      result?: "homeWin" | "awayWin" | "tie" | null;
      isTiebreakerGame: boolean;
    }[];
    rows: {
      userId: string;
      entryId: string;
      displayName: string;
      photoUrl?: string | null;
      isViewer: boolean;
      points: number;
      wins: number;
      losses: number;
      pushes: number;
      missed: number;
      roundRank?: number | null;
      isRoundWinner: boolean;
      tiebreakerGuess?: number | null;
      tiebreakerDiff?: number | null;
      picks: {
        eventId: string;
        visibility: "visible" | "hidden" | "noPick";
        teamId?: string | null;
        confidenceRank?: number | null;
        spreadLine?: number | null;
        outcome?: "win" | "loss" | "push" | "pending" | null;
        points?: number | null;
        isMissed: boolean;
      }[];
    }[];
    actualTiebreakerTotal: number | null;
    filters: {
      rounds: { roundId: string; label: string }[];
      members: { userId: string; displayName: string }[];
    };
  };
};

export type typePickemResultsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemResultsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemResultsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemResultsGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    userId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemResultsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemResultsGetBody);
  }

  return async function postPickemResultsGet(
    payload: typePickemResultsGetBody,
  ): Promise<typePickemResultsGetOutput200 | typePickemResultsGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemResultsGet" failed before calling the network. #10b5787b71f0`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#10b5787b71f0" },
        },
        data: null,
      } as typePickemResultsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/results-get`,
      httpMethod: "POST",
      options,
    })) as typePickemResultsGetOutput200 | typePickemResultsGetOutput400;
  };
}
